import cimg from '../Images/aboutImg.svg';
const FacultiesData = [{
        id: 1,
        cname: "Full Name",
        cimage: cimg,
        crate: "3",
    },
    {
        id: 2,
        cname: "Full Name",
        cimage: cimg,
        crate: "3",
    },
    {
        id: 3,
        cname: "Full Name",
        cimage: cimg,
        crate: "3",
    },
    // {
    //     id: 4,
    //     cname: "Complete Co-ordinate Geometry |JEE Mains and Advanced|",
    //     cimage: cimg,
    //     crate: "3",
    //     cprice: "INR 4000/-"
    // },
];
export default FacultiesData;